'use strict';

import AxiosService from '../AxiosService';

const ADDRESS_ENDPOINT = "/api/v1/data/addresses";
const ADDRESS_CONTROLLER_ENDPOINT = "/api/v1/addresses";
const JOB_CHANGE = "/api/v1/addresses/job"
const SURVEY_READINESS_CHANGE = "/api/v1/addresses/survey-ready"

export default class AddressService {
    constructor() {
        this.service = new AxiosService();
    }

    search(postcode, homeNumber) {
        return this.service.get(ADDRESS_ENDPOINT, {
            params: {
                postcode: postcode,
                homeNumber: homeNumber
            }
        })
    }

    resolveStatuses(statuses) {
        let statusesString = statuses.map(e => e.key).join(",");
        return this.service.get(ADDRESS_CONTROLLER_ENDPOINT + "?statuses=" + statusesString);
    }

    loadAddressesByAssignmentIds(ids) {
        return this.service.get(`${ADDRESS_CONTROLLER_ENDPOINT}/assignments/${ids}/planner`)
    }

    changeJob(uniqueIdAddress, job) {
        let payload = {
            "uniqueIdAddress": uniqueIdAddress,
            "job": job,
        };
        return this.service.put(JOB_CHANGE, payload);
    }

    changeSurveyReadiness(payload) {
        return this.service.post(SURVEY_READINESS_CHANGE, payload);
    }
}